import { render, staticRenderFns } from "./ResetClassroomModal.vue?vue&type=template&id=0dae2bde&scoped=true"
import script from "./ResetClassroomModal.vue?vue&type=script&lang=js"
export * from "./ResetClassroomModal.vue?vue&type=script&lang=js"
import style0 from "./ResetClassroomModal.vue?vue&type=style&index=0&id=0dae2bde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dae2bde",
  null
  
)

export default component.exports